const colors = {
  red: '#F36F5F',
  bg: '#F2EEE6',
  green: '#C0D84B',
  slate: '#231F20',
  gray: '#545554',
  white: '#FFF',
};

export default colors;